import { render, staticRenderFns } from "./ProjectsModal.vue?vue&type=template&id=37ec6b2e&"
import script from "./ProjectsModal.vue?vue&type=script&lang=js&"
export * from "./ProjectsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ec6b2e')) {
      api.createRecord('37ec6b2e', component.options)
    } else {
      api.reload('37ec6b2e', component.options)
    }
    module.hot.accept("./ProjectsModal.vue?vue&type=template&id=37ec6b2e&", function () {
      api.rerender('37ec6b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsModal.vue"
export default component.exports